import { combineReducers } from 'redux';

import {
  RECEIVED_INSTALLED_APPS,
  SET_IS_POPUP,
  SET_COMPONENT_ID,
  SET_ORIGINAL_COMPONENT_ID,
  SET_APP_COMPONENT,
  SET_IS_SOCIAL,
  SET_VIEW_MODE,
  SET_SIGNED_INSTANCE,
} from './actions';
import { createGenericReducer as createReducer } from '../../services/create-reducer';

const DEFAULT_SITE_LOCALE = 'en';

const toPayload = (action) => action.payload;

const installedApps = createReducer({}, { [RECEIVED_INSTALLED_APPS]: toPayload });
const isPopup = createReducer(false, { [SET_IS_POPUP]: toPayload });
const componentId = createReducer(null, { [SET_COMPONENT_ID]: toPayload });
const originalComponentId = createReducer(null, {
  [SET_ORIGINAL_COMPONENT_ID]: toPayload,
});
const appComponent = createReducer(null, { [SET_APP_COMPONENT]: toPayload });
const originalAppComponent = createReducer(null, {});
const filters = createReducer({}, {});
const sorts = createReducer({}, {});
const isSocial = createReducer(false, { [SET_IS_SOCIAL]: toPayload });
const isMobile = createReducer(false);
const siteLocale = createReducer(DEFAULT_SITE_LOCALE);
const metaSiteId = createReducer(null, {});
const basePath = createReducer(null, {});
const appDefId = createReducer(null, {});
const viewMode = createReducer(null, { [SET_VIEW_MODE]: toPayload });
const isDemoMode = createReducer(false);
const isSocialChatInstalled = createReducer(false);
const signedInstance = createReducer(null, { [SET_SIGNED_INSTANCE]: toPayload });
const isRtlLocale = createReducer(false);
const isStudio = createReducer(false);

export default combineReducers({
  installedApps,
  isPopup,
  componentId,
  originalComponentId,
  appComponent,
  originalAppComponent,
  filters,
  sorts,
  isSocial,
  siteLocale,
  metaSiteId,
  isMobile,
  basePath,
  appDefId,
  viewMode,
  isDemoMode,
  isSocialChatInstalled,
  signedInstance,
  isRtlLocale,
  isStudio,
});
